import { callTangerineApi } from 'domains/tangerine/api'

/** @param {string} method @param {string} path @param {object} [params] */
const apiCall = (method, path, params) =>
  callTangerineApi({ method, path, params })

/**
 * REST API client for custom highlight cards and their content.
 * All methods return Promises that resolve to the API response.
 */
export const highlightsApi = {
  /** Lists all custom highlight cards. */
  listCards: () => apiCall('GET', '/api/v3/highlights_cards/custom/card'),

  /** Creates a new highlight card. @param {object} data - Card fields */
  createCard: (data) =>
    apiCall('POST', '/api/v3/highlights_cards/custom/card', data),

  /** Updates an existing highlight card. @param {string} cardId @param {object} data */
  updateCard: (cardId, data) =>
    apiCall('PATCH', `/api/v3/highlights_cards/custom/card/${cardId}`, data),

  /** Deletes a highlight card. @param {string} cardId */
  deleteCard: (cardId) =>
    apiCall('DELETE', `/api/v3/highlights_cards/custom/card/${cardId}`),

  /** Lists content for all custom highlight cards. */
  listAllContent: () =>
    apiCall('GET', '/api/v3/highlights_cards/custom/content/all'),

  /** Creates content for a highlight card. @param {object} data - Must include card_id */
  createContent: (data) =>
    apiCall('POST', '/api/v3/highlights_cards/custom/content', data),

  /** Updates content for a highlight card. @param {string} cardId @param {object} data */
  updateContent: (cardId, data) =>
    apiCall('PATCH', `/api/v3/highlights_cards/custom/content/${cardId}`, data),

  /** Deletes content for a highlight card. @param {string} cardId */
  deleteContent: (cardId) =>
    apiCall('DELETE', `/api/v3/highlights_cards/custom/content/${cardId}`),

  /** Sends a push notification for a highlight card. @param {object} data */
  sendPushNotification: (data) =>
    apiCall('POST', '/api/v3/highlights_cards/custom/push', data),
}
